module.exports = __webpack_public_path__ + "img/alipayactive.61160c02.png";